import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 39,
  height: 39,
}

const Concierge = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 38.5 38.462'
  >
    <g fill={color}>
      <path
        d='M346.481,7.433a3.552,3.552,0,0,0,.832-2.287V0h-7.136V5.146a3.551,3.551,0,0,0,.832,2.287,6.572,6.572,0,0,0-3.837,5.976V23.964a1.88,1.88,0,0,0,1.878,1.878,1.9,1.9,0,0,0,.226-.014v12.6H340.4V25.266a1.866,1.866,0,0,0,.526-1.3V22.537h5.634v1.427a1.872,1.872,0,0,0,.526,1.3V38.425h1.127v-12.6a1.89,1.89,0,0,0,.225.014,1.879,1.879,0,0,0,1.878-1.878V13.409A6.611,6.611,0,0,0,346.481,7.433ZM341.3,1.127h4.883V2.7H341.3Zm0,2.7h4.883V5.146a2.442,2.442,0,0,1-4.883,0Zm-1.5,20.133a.751.751,0,1,1-1.5,0V22.537h1.5Zm0-2.554h-1.5v-1.2h1.5Zm9.39,2.554a.751.751,0,1,1-1.5,0V22.537h1.5Zm0-2.554h-1.5v-1.2h1.5Zm0-2.329h-1.5V12.959h-1.127V21.41h-5.634V12.959H339.8v6.123h-1.5V13.409a5.447,5.447,0,0,1,3.693-5.157,3.556,3.556,0,0,0,3.507,0,5.474,5.474,0,0,1,3.693,5.157Zm0,0'
        transform='translate(-311.818)'
      />
      <path d='M417.094,329.18h1.127v13.672h-1.127Zm0,0' transform='translate(-385.73 -304.427)' />
      <path
        d='M144.08,283.252a2.313,2.313,0,0,0-1.93-.479l-4.271.863a1.886,1.886,0,0,0,.373,3.734h4.357a2.321,2.321,0,0,0,1.47-4.118Zm-1.47,2.991h-4.357a.759.759,0,0,1-.15-1.5l4.271-.863a1.211,1.211,0,0,1,.238-.024,1.194,1.194,0,0,1,0,2.389Zm0,0'
        transform='translate(-126.113 -261.467)'
      />
      <path d='M0,300.039H8.264v1.127H0Zm0,0' transform='translate(0 -277.477)' />
      <path d='M0,331.676H8.264V332.8H0Zm0,0' transform='translate(0 -306.736)' />
      <path d='M0,362.645H8.264v1.127H0Zm0,0' transform='translate(0 -335.376)' />
      <path
        d='M20.884,103.785H16.758L13.524,98.9H0v1.127H12.919l5.431,8.2L16.123,109.8H0v1.127H16.48l2.493-1.752,1.2,1.809v9.07a1.692,1.692,0,0,1-1.69,1.69H0v1.127H10.1v3.193a3.869,3.869,0,0,0,7.738,0v-3.193h.639a2.82,2.82,0,0,0,2.817-2.817v-9.41l-1.8-2.723h1.39a2.066,2.066,0,1,0,0-4.132Zm-4.17,22.274a2.742,2.742,0,1,1-5.484,0v-3.193h5.484Zm4.17-19.269H18.748L17.5,104.912h3.38a.939.939,0,0,1,0,1.878Zm0,0'
        transform='translate(0 -91.465)'
      />
      <path
        d='M29.164,163.763l2.337-2.337.8.8-2.337,2.337Zm0,0'
        transform='translate(-26.971 -149.288)'
      />
      <path d='M70.844,141.027l.8-.8.8.8-.8.8Zm0,0' transform='translate(-65.517 -129.685)' />
      <path
        d='M83.113,163.763l2.337-2.337.8.8L83.91,164.56Zm0,0'
        transform='translate(-76.864 -149.288)'
      />
      <path d='M124.793,141.031l.8-.8.8.8-.8.8Zm0,0' transform='translate(-115.409 -129.689)' />
      <path d='M226.777,367.641H227.9v1.127h-1.127Zm0,0' transform='translate(-209.724 -339.996)' />
      <path d='M419.09,158.344h1.127V164.8H419.09Zm0,0' transform='translate(-387.576 -146.437)' />
      <path d='M419.09,128.375h1.127V129.5H419.09Zm0,0' transform='translate(-387.576 -118.722)' />
    </g>
  </svg>
)

export default Concierge
